(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ps19-hero"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const pushEvent = (eventName, detail = {}) => {
      if (!eventName) return;
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: eventName, ...detail });
    };

    const preserveQuery = () => {
      const source = new URLSearchParams(window.location.search);
      const allowed = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'gclid', 'fbclid'];
      document.querySelectorAll('[data-ps19-preserve-query]').forEach((link) => {
        if (link.dataset.ps19QueryReady === 'true') return;
        const target = new URL(link.href, window.location.origin);
        allowed.forEach((key) => {
          if (source.has(key)) target.searchParams.set(key, source.get(key));
        });
        link.href = target.toString();
        link.dataset.ps19QueryReady = 'true';
      });
    };

    const bindClicks = () => {
      document.querySelectorAll('[data-ps19-event]').forEach((element) => {
        if (element.dataset.ps19EventReady === 'true') return;
        element.addEventListener('click', () => {
          pushEvent(element.dataset.ps19Event, {
            section: element.closest('[data-ps19-section]')?.dataset.ps19Section || '',
            label: element.textContent.trim()
          });
        });
        element.dataset.ps19EventReady = 'true';
      });
    };

    const observeSections = () => {
      if (!('IntersectionObserver' in window)) return;
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting || entry.target.dataset.ps19Viewed === 'true') return;
          entry.target.dataset.ps19Viewed = 'true';
          pushEvent('ps19_section_view', { section: entry.target.dataset.ps19Section || '' });
          if (entry.target.dataset.ps19Section === 'comparison') pushEvent('ps19_compare_view');
          observer.unobserve(entry.target);
        });
      }, { threshold: 0.35 });
      document.querySelectorAll('[data-ps19-section]').forEach((section) => {
        if (section.dataset.ps19Observed === 'true') return;
        section.dataset.ps19Observed = 'true';
        observer.observe(section);
      });
    };

    const bindFaqs = () => {
      document.querySelectorAll('[data-ps19-faq]').forEach((faq) => {
        if (faq.dataset.ps19FaqReady === 'true') return;
        faq.addEventListener('toggle', () => {
          if (faq.open) pushEvent('ps19_faq_open', { question: faq.querySelector('summary')?.textContent.trim() || '' });
        });
        faq.dataset.ps19FaqReady = 'true';
      });
    };

    const bindVideos = () => {
      document.querySelectorAll('[data-ps19-demo-video] video').forEach((video) => {
        if (video.dataset.ps19VideoReady === 'true') return;
        video.addEventListener('play', () => pushEvent('ps19_demo_start'));
        video.addEventListener('timeupdate', () => {
          if (!video.duration) return;
          if (video.currentTime / video.duration >= 0.5 && video.dataset.ps19Half !== 'true') {
            video.dataset.ps19Half = 'true';
            pushEvent('ps19_demo_50');
          }
        });
        video.addEventListener('ended', () => pushEvent('ps19_demo_complete'));
        video.dataset.ps19VideoReady = 'true';
      });
    };

    const bindSticky = () => {
      const sticky = document.querySelector('[data-ps19-sticky]');
      const hero = document.querySelector('#ps19-hero');
      const purchase = document.querySelector('#ps19-purchase');
      if (!sticky || !hero || !purchase || sticky.dataset.ps19StickyReady === 'true') return;
      const update = () => {
        const pastHero = hero.getBoundingClientRect().bottom < 0;
        const beforePurchase = purchase.getBoundingClientRect().top > window.innerHeight;
        sticky.classList.toggle('is-visible', pastHero && beforePurchase);
      };
      window.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      sticky.dataset.ps19StickyReady = 'true';
      update();
    };

    const init = () => {
      const root = document.querySelector('[data-ps19-root]');
      if (root && root.dataset.ps19PageViewed !== 'true') {
        root.dataset.ps19PageViewed = 'true';
        pushEvent('ps19_lp_view');
      }
      preserveQuery();
      bindClicks();
      observeSections();
      bindFaqs();
      bindVideos();
      bindSticky();
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init, { once: true });
    } else {
      init();
    }
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();
})();
